import { Box, Flex, Link } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { CONTACT } from "./homeContent";
import { Body, Cta, H2, Inner, Kicker, Lead, Mono, Section, useHomeTokens } from "./primitives";

/** #contact — "Let's talk about your infrastructure". The footer's Contact link lands on `/#cta-section`. */
export const Contact = () => {
  const t = useHomeTokens();
  return (
    <Section id="contact" alt textAlign="center" py={{ base: 16, md: "120px" }}>
      {/* Alias: the site footer links to /#cta-section. */}
      <Box id="cta-section" position="absolute" top={0} aria-hidden="true" />
      <Inner maxW="760px">
        <Flex direction="column" align="center" gap="22px">
          <Kicker>Get in touch</Kicker>
          <H2 fontSize="clamp(2.1rem, 4vw, 3.3rem)" lineHeight="1.06">
            Let's talk about your infrastructure
          </H2>
          <Lead fontSize="1.08rem">
            Call or send a message to discuss your business requirements — services, pricing, and how we can help
            transform your business with cutting-edge technology.
          </Lead>
          <Flex wrap="wrap" gap="12px" justify="center" mt="8px">
            <Cta
              href={CONTACT.bookingPath}
              newTab
              title="Opens Tom's booking page in a new tab — pick a time for a free consultation. Nothing is charged."
            >
              Book a free consultation
            </Cta>
            <Cta
              href={CONTACT.phoneHref}
              variant="ghost"
              title="Calls Tom on his mobile (opens your phone dialler)."
            >
              {CONTACT.phoneDisplay}
            </Cta>
          </Flex>
          <Link
            href={CONTACT.emailHref}
            fontSize="1rem"
            mt="6px"
            color={t.primary}
            wordBreak="break-word"
            title="Opens your email client with a new message to Tom."
            _hover={{ color: t.secondary, textDecoration: "underline" }}
          >
            {CONTACT.email}
          </Link>
          <Mono fontSize="11px" color={t.textFaint} mt="10px" px={2}>
            {CONTACT.legalLine}
          </Mono>
          <Body fontSize=".88rem" color={t.textMuted} maxW="640px">
            Before you call, the{" "}
            <Link
              as={RouterLink}
              to="/terms"
              color={t.primary}
              textDecoration="underline"
              title="Opens the terms of working with TMS. Reading only."
              _hover={{ color: t.secondary }}
            >
              terms of working with TMS
            </Link>{" "}
            set out what you are buying, that your data is always yours to export, and the published price of every
            exit.
          </Body>
        </Flex>
      </Inner>
    </Section>
  );
};
